import React from 'react';
import './GNB.scss';
import { handleLinkClick, navigateTo } from '../../Utils/routing';
import { useSession, useSignIn } from '@/Recoil/Session/Session';

interface GNBProps {
    rightContent?: React.ReactNode;
    onLogoClick?: () => void;
    onDownloadClick?: () => void;
}

const GNB: React.FC<GNBProps> = ({ rightContent, onLogoClick, onDownloadClick }) => {
    const { session } = useSession();
    const { logout } = useSignIn();
    const currentPath = window.location.pathname;

    const handleLogoClick = () => {
        if (onLogoClick) {
            onLogoClick();
        } else {
            // If we're on an admission page, go to /admission, otherwise go to home
            if (currentPath.startsWith('/admission')) {
                navigateTo('/admission');
            } else {
                navigateTo('/');
            }
        }
    };

    return (
        <div className="Gnb">
            <div className="Container">
                <div className="Logo" onClick={handleLogoClick}>
                    <img src={"/img/mate-logo.svg"} alt="MATE" style={{width: 24, height: 24}} />
                    <span className="LogoText">{"MATE"}</span>
                </div>
                
                
                <div className="Right">
                    <button className="DownloadButton" onClick={()=>window.open("https://koreanmate.onelink.me/Tkco/y94asact")}>
                        <svg className="DownloadIcon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 12L3 7L4.4 5.6L7 8.2V0H9V8.2L11.6 5.6L13 7L8 12ZM0 16V11H2V14H14V11H16V16H0Z" fill="#F6F6F6"/>
                        </svg>
                        <span className="DownloadText">{"app download"}</span>
                        
                    </button>
                    
                    {session.email
                    ?<div className="user-menu">
                        <div className="user-info">
                            <span className="username">{session?.name || 'User'}</span>
                            {session?.email && (
                                <img src={session.image} alt="Profile" className="user-avatar" onError={(e) => {
                                    const target = (e.target as HTMLElement);
                                    target.style.opacity = '0';
                                }} />
                            )}
                        </div>
                        <div className="dropdown-menu">
                            <a href="/purchase/history" className="dropdown-item" onClick={handleLinkClick}>{"My Sessions"}</a>
                            <button onClick={logout} className="dropdown-item logout">{"Log Out"}</button>
                        </div>
                    </div>
                    :<a href={`/login?redirectTo=${encodeURIComponent(currentPath)}`} className="login-button">
                        <img src="/img/user-avatar.svg" alt="Login" className="user-avatar" />
                    </a>}

                    {rightContent}
                </div>
            
            </div>
        </div>
    );
};

export default GNB;